import { observable, action, } from 'mobx';
import { isDataExist } from 'Utils/dataTools';
import * as services from '../services/basic';
import { message } from 'antd';

class ToolsLife {
  @observable isLoading = false
  @observable tableList = []
  @observable waresList = []
  @observable waresPage = {pageIndex:1,pageSize:10}
  @observable tablePage = {pageIndex:1,pageSize:10}
  @observable name = ''

  /* 弹窗 */
  @observable type = 0
  @observable formData = {}
  @observable visible = false
  @observable selectedRowKeys = []
  @observable plantList = []

  @action.bound async getData(type,params) {
    try {
      this.isLoading = true
      let req = !type ? 1 : 2 /*1：模具，2：工装，3：夹具*/
      let res = await services.getRequest(services.requestUrl.getToolsLife,{...params,pattern:req});
      /*查询的四个参数：↑ pageIndex，pageSize，type(选择模具or工装)，name(输入的名字)*/
      this.isLoading = false
      if(isDataExist(res)){
        this.tablePage = res.data.data.page
        this.tableList = res.data.data.items;
      }
    } catch (error) {
      console.log(error);
    }
  }
  
  @action async getReportCount(params) {
    try {
      let res = await services.getRequest(services.requestUrl.getReportCount,params);
      if(isDataExist(res)){
        let histogramDs = [{
          name: 'failCount'
        }, {
          name: 'successCount'
        }];
        histogramDs.map(ele => {
          res.data.data.map(item => {
            ele[item.reportTime] = item[ele.name];
          });
        });
        this.histogramDs = histogramDs;
      }
    } catch (error) {
      console.log(error);
    }
  }
  @action clearData(){
    this.isLoading = false
    this.tableList = []
    this.tablePage = {pageIndex:1,pageSize:10}
    this.name = ''
  
    /* 弹窗 */
    this.type = 0
    this.formData = {}
    this.visible = false
    this.selectedRowKeys = []
    this.plantList = []
  }
}
let ToolsLifeStore = new ToolsLife();
export default ToolsLifeStore;